import getBasePath from '../../../../common/functions/api-resource';
import genericActions from './generic-resource';

const basePath = getBasePath('api', 'produto');

const produtoActions = {
  ...genericActions(basePath),
  buscar: { method: 'GET', url: `${basePath}/{id}` },
  ativarMassa: { method: 'PUT', url: `${basePath}/ativacao-massa` },
  listarFiltrado: { method: 'GET', url: `${basePath}?colunaOrdenacao=nom_produto&tamanhoPagina={size}&numeroPagina={page}` },
  listarAutocompletePagina: { method: 'GET', url: `${basePath}?colunaOrdenacao=nom_produto` },
  listarAutocompleteRelatorio: { method: 'GET', url: `${basePath}/relatorio?colunaOrdenacao=nom_produto{&id_marca*}{&id_familia*}{&id_linha_produto*}{&idUnidadeNegocio*}` },
  listarAutocomplete: { method: 'GET', url: `${basePath}?tamanhoPagina=6&numeroPagina=1&autocomplete={autocomplete}&indAtivo=true` },
  buscarExtensoesRelacionadas: { method: 'GET', url: `${basePath}/extensao-relacionada?nome={nome}&indAtivo=true&idNivelExtensao={idNivelExtensao}&colunaOrdenacao=nom_extensao{&idExtensaoFiltro*}` },
  buscarExtensoesRelacionadasRelatorio: { method: 'GET', url: `${basePath}/extensao-relacionada/relatorio?nome={nome}&indAtivo=true&idNivelExtensao={idNivelExtensao}&colunaOrdenacao=nom_extensao{&idExtensaoFiltro*}` },
};

export default resource => resource(`${basePath}`, {}, produtoActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/produto.js